import {
	changePage,
	downloadClaims,
	getClaims,
} from 'feature/claims/claimsSlice';
import useDevice from 'hooks/DesktopDevice.hook';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import Button from 'styles/button/Button';
import Pagination from 'styles/pagination/Pagination';
import Stack from 'styles/stack/Stack';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

const ClaimListFooter = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const { isDesktop } = useDevice();
	const { pages, page } = useSelector((store: RootState) => store.claims);
	const { selectedItems, downloadAll } = useSelector(
		(store: RootState) => store.tableSelectedItems,
	);

	const handleChangePage = (
		event: React.ChangeEvent<unknown>,
		value: number,
	) => {
		event.preventDefault();
		dispatch(changePage(value));
		dispatch(getClaims(''));
	};

	const handleClick = (type: string) => {
		dispatch(downloadClaims({ uuid: undefined, type: type }));
	};

	return (
		<Stack
			direction={'row'}
			position={'relative'}
			sx={{ my: !!isDesktop ? 4.25 : 3 }}
			alignItems={'center'}
			justifyContent={'space-between'}
		>
			<Stack
				direction={'row'}
				flexGrow={1}
				sx={{
					justifyContent: 'flex-start',
					alignItems: 'center',
				}}
			>
				{pages > 1 ? (
					<Pagination page={page} count={pages} onChange={handleChangePage} />
				) : null}
			</Stack>
			<Stack
				direction={'row'}
				position={'absolute'}
				right={0}
				sx={{
					gap: '10px',
					alignContent: 'center',
					justifyContent: 'flex-end',
				}}
			>
				<Button
					type="button"
					variant="contained"
					disabled={selectedItems.length > 0 || downloadAll ? false : true}
					fullWidth={false}
					onClick={() => handleClick('XLSX')}
				>
					{tClientLabels('view-claims.exportButton.XLSX')}
				</Button>
				<Button
					type="button"
					variant="contained"
					disabled={selectedItems.length > 0 || downloadAll ? false : true}
					fullWidth={false}
					onClick={() => handleClick('PDF')}
				>
					{tClientLabels('view-claims.exportButton.PDF')}
				</Button>
			</Stack>
		</Stack>
	);
};

export default ClaimListFooter;
